import { Box, SxProps, Theme } from "@mui/material";
import React from "react";
import useThemeStore from "@/shared/stores/useThemeStore";
import { CardTocPageItem } from "./CardTocDrawer";
import { CardToc } from "./CardToc";
import ImpactCardTalentToc from "@/cards/impact-card/components/ImpactCardTalentToc";

type CardTocPageProps = {
  frameSx: SxProps<Theme>;
  isMobile: boolean;
  cardTitle?: string;
  cardDescription?: string;
  pageCount: number;
  pages: CardTocPageItem[];
  currentPage: number;
  onSelectPage: (pageIndex: number) => void;
  talentCubeToc?: boolean;
  canEditCubes?: boolean;
  partnerEditOnly?: boolean;
  coverImageUrl?: string;
  onSelectImpactSection?: (sectionKey: string) => void;
  onSelectImpactCube?: (cubeId: string) => void;
  onSelectImpactColumn?: (columnId: string, cubeId?: string, sectionKey?: string) => void;
};

export const CardTocPage: React.FC<CardTocPageProps> = ({
  frameSx,
  isMobile,
  cardTitle = "",
  pages,
  currentPage,
  onSelectPage,
  talentCubeToc = false,
  canEditCubes = false,
  partnerEditOnly = false,
  coverImageUrl,
  onSelectImpactSection,
  onSelectImpactCube,
  onSelectImpactColumn,
}) => {
  const { darkMode } = useThemeStore();
  const contentPages = pages.filter((page) => page.pageIndex !== currentPage);

  return (
    <Box sx={frameSx}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          bgcolor: talentCubeToc ? "#FAF8F2" : darkMode ? "#111014" : "#f8f8f8",
          borderRadius: isMobile ? 0 : "16px",
          border: isMobile
            ? "none"
            : talentCubeToc
              ? "1px solid rgba(16,44,36,.10)"
              : darkMode
                ? "1px solid rgba(255,255,255,0.1)"
                : "1px solid rgba(26,21,40,0.1)",
          display: "flex",
          flexDirection: "column",
          boxShadow: isMobile
            ? "none"
            : darkMode
              ? "0 18px 40px rgba(0,0,0,0.3)"
              : "0 16px 40px rgba(26,21,40,0.14)",
          position: "relative",
          overflow: "hidden",
          px: talentCubeToc ? 0 : { xs: 1.5, sm: 1.65 },
          pt: talentCubeToc
            ? 0
            : {
                xs: 1.5,
                sm: 1.75,
              },
          pb: talentCubeToc
            ? 0
            : {
                xs: 1.25,
                sm: 1.5,
              },
        }}
      >
        {talentCubeToc ? (
          <ImpactCardTalentToc
            canEdit={canEditCubes}
            partnerEditOnly={partnerEditOnly}
            coverImageUrl={coverImageUrl}
            onSelectSection={onSelectImpactSection}
            onSelectCube={(cube) => onSelectImpactCube?.(cube.id)}
            onSelectColumn={(column, cube) =>
              onSelectImpactColumn?.(column.id, cube.id, column.sectionKey)
            }
          />
        ) : (
          <CardToc
            talentName={cardTitle}
            pageCount={contentPages.length}
            pages={contentPages}
            currentPage={currentPage}
            onSelectPage={onSelectPage}
          />
        )}
      </Box>
    </Box>
  );
};

export default CardTocPage;
